import { StateCreator } from 'zustand';
import {
	SignatureRequestQuickFlowDrawerCloseTypes,
	SignatureRequestQuickFlowDrawerSteps,
} from '../../constants';
import { storeResetFns } from '.';

type SignatureRequestMetadata = {
	drawerCloseType: SignatureRequestQuickFlowDrawerCloseTypes | null;
	documentRID: string;
	redirectPath: string;
	containerRID: string;
	completedSteps?: readonly string[];
	currentStep?: SignatureRequestQuickFlowDrawerSteps;
	loadingInProgress?: boolean;
	csvData?: any;
	csvFileName?: string;
};

type State = {
	signatureRequestMetadata: SignatureRequestMetadata;
};

type Actions = {
	updateSignatureRequestMetadata: (
		data: Partial<SignatureRequestMetadata> | SignatureRequestMetadata
	) => void;
};

export type SignatureRequestMetadataStore = State & Actions;

const initialState = {
	signatureRequestMetadata: {
		drawerCloseType: null,
		documentRID: null,
		redirectPath: null,
		containerRID: null,
		completedSteps: [],
		currentStep: SignatureRequestQuickFlowDrawerSteps.AddRecipients,
		loadingInProgress: false,
		csvData: null,
	},
};

export const createSignatureRequestMetadataSlice: StateCreator<
	SignatureRequestMetadataStore
> = (set, get) => {
	storeResetFns.add(() => {
		set(initialState);
	});

	return {
		...initialState,
		updateSignatureRequestMetadata: (
			data: Partial<SignatureRequestMetadata> | SignatureRequestMetadata
		) => {
			const { signatureRequestMetadata } = get();

			set({
				signatureRequestMetadata: { ...signatureRequestMetadata, ...data },
			});
		},
	};
};
